import inView from 'in-view'

/**
* Code that should be run on every page.
*/
(function ($) {
  $(document).on('turbolinks:load', () => {
    trackPromotions()
    inViewSettings()
  })

  /**
  * Adds promotion impression/click tracking to all promotions found on the page.
  */
  function trackPromotions() {
    const container = 'body'


    const selector = '.js-promotion'

    $(container).track({
      type: 'promo impression',
      selector,
    })
  }

  /**
  * Sets up in-view.js global settings.
  */
  function inViewSettings() {
    // An element is considered "in view" once it is within 500px of the viewport.
    inView.offset(-500)
  }
}(jQuery))
